import { useMemo } from 'react';

import { useCageController_getCageTypes } from '@/services/hooks';

import { mapCageTypeResponseToDomain } from './mappers';
import type { UseGetCageTypesResult } from './types';

export const useGetCageTypes = (): UseGetCageTypesResult => {
    const getCageTypesQuery = useCageController_getCageTypes();

    const cageTypes = useMemo(
        () => mapCageTypeResponseToDomain(getCageTypesQuery.data?.data ?? { cageTypes: [] }),
        [getCageTypesQuery.data?.data]
    );

    return {
        ...getCageTypesQuery,
        isLoading: getCageTypesQuery.isPending,
        data: cageTypes,
    };
};
